import React, { FC } from 'react';
import { RoomExtraOption } from 'shared-types/Room';
import { OptionsBox } from './OptionsBox';
import { TopRow, BottomRow, ToggleExtraWrapper } from './Options.styles';
import { controlTypes } from './controlTypes';
import { Controller, useFormContext } from 'react-hook-form';
import { QuantityPicker } from '@common/components/QuantityPicker/QuantityPicker';
import { ToggleExtra } from '@common/components/Extras/controls/ToggleExtra';
import {
  OvernightPackageRoomExtra,
  PackagesFormValues,
} from '@features/DynamicPackagesConfigurationWizard/types';

type OptionsProps = {
  index: number;
  selectedOption?: RoomExtraOption;
  isSelected?: boolean;
} & OvernightPackageRoomExtra;

export const Options: FC<OptionsProps> = ({ index, isSelected, selectedOption, ...extra }) => {
  const maxQuantity = selectedOption?.maxQuantity || extra?.maxQuantity;
  const { control } = useFormContext<PackagesFormValues>();
  return (
    <OptionsBox>
      <TopRow>{controlTypes(index, extra as OvernightPackageRoomExtra)}</TopRow>
      <BottomRow>
        {!!maxQuantity && (
          <Controller
            name={`extras.${index}.quantity`}
            control={control}
            render={({ field }) => (
              <QuantityPicker
                input={{
                  value: field.value ?? 0,
                  onChange: field.onChange,
                }}
                {...field}
                maxValue={maxQuantity}
              />
            )}
          />
        )}
        <ToggleExtraWrapper>
          <Controller
            name={`extras.${index}.isSelected`}
            control={control}
            render={({ field }) => (
              <ToggleExtra
                input={{
                  value: field.value,
                  onChange: (value) => {
                    field.onChange(value);
                  },
                }}
                isDisabled={!isSelected && !selectedOption}
                {...field}
              />
            )}
          />
        </ToggleExtraWrapper>
      </BottomRow>
    </OptionsBox>
  );
};
